module.exports = __webpack_public_path__ + "media/images/icons/facebook_white_login-65cbf47b40980a0d738fb144aed0ceb1.svg";